<template>
    <div class="input-group">
        <input
            v-model="valueComponent1"
            class="form-control"
            type="text"
            :placeholder="placeholder"
        />
        <span class="input-group-text">and</span>
        <input
            v-model="valueComponent2"
            class="form-control"
            type="text"
            :placeholder="placeholder"
        />
    </div>
</template>

<script>

export default {
    name: "CCQueryBuilderRuleTypeBetween",
    components: {},

    data() {
        return {
            valueComponent1: null,
            valueComponent2: null,
        };
    },

    watch: {
        value(newValue) {
            this.valueComponent1 = newValue[0];
            this.valueComponent2 = newValue[1];
        },
        valueComponent1(newValue) {
            this.$emit("update:value", [newValue, this.valueComponent2]);
            this.$emit("change", [newValue, this.valueComponent2]);
        },
        valueComponent2(newValue) {
            this.$emit("update:value", [this.valueComponent1, newValue]);
            this.$emit("change", [this.valueComponent1, newValue]);
        },
    },

    props: {
        value: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
        },
    },

    mounted() {
        this.valueComponent1 = this.value[0];
        this.valueComponent2 = this.value[1];
    },
};
</script>
